import React, { Component } from 'react';

import Links from '../Tools/links';
import Carousel from '../Tools/Carousel';

class ChoirMiddle extends Component {
  state = {
    imageList: [
      {
        img:
          'https://res.cloudinary.com/dwvrok1le/image/upload/v1547231457/mid.jpg',
        school: 'Walnut Grove Middle School',
      },
    ],
  };
  render() {
    const { files } = this.props;
    return (
      <div className="band_middle scroll">
        <h2 className="band_title">Middle School</h2>
        <Carousel imageList={this.state.imageList} />
        <div className="band_high_sub">
          <div className="band_high_btm">
            <div>
              <h3>Solo & Ensemble</h3>
              <Links input={files.middleSolo} />
            </div>
            <div>
              <h3>Concert</h3>
              <Links input={files.middleConcert} />
            </div>
          </div>
          <div className="border_line" />
          <div className="band_high_btm">
            <h3>Contest Schedules</h3>
            <Links input={files.schedules} />
          </div>
        </div>
      </div>
    );
  }
}

export default ChoirMiddle;



// WEBPACK FOOTER //
// ./src/Components/Choir/ChoirMiddle.js